import { Component, OnInit } from '@angular/core';
import { DashboardService } from 'src/app/dashboard.service';
import {ReportService} from '../../services/report/report.service';

import { CompanyService } from '../../services/Company/company.service';
import { OthersService} from '../../services/others/others.service';


@Component({
  selector: 'app-new-connect',
  templateUrl: './new-connect.component.html',
  styleUrls: ['./new-connect.component.scss']
})
export class NewConnectComponent implements OnInit {
  public newConnects = []
  currentCompany:any = [];

  constructor(private dashboardService: DashboardService,private companyService:CompanyService, private reportService:ReportService,private otherService:OthersService) {

    this.currentCompany = companyService.getCurrentCompany();


   

  }
  ngOnInit() {
   // this.getNewConnects();
   if (this.currentCompany) {
    let role_id = this.currentCompany.role_id;

    if (role_id == 1 || role_id == 2 || role_id == 4) {
    
        this.getStats1();
    }
   
  }
  else {
    this.otherService.currentComp$.subscribe(res => {
      //console.log("TTTT123=== " + JSON.stringify(res));
      //this.staff = res;
      //this.fillForm();
      //alert("I am here too")
      if (res) {
        this.currentCompany = res;
        let role_id = this.currentCompany.role_id;

        if (role_id == 1 || role_id == 2 || role_id == 4) {
          this.getStats1();
        }
        
      }
      
    });
  }
  
  }

  getNewConnects() {
    this.dashboardService.getTopDepartments()
      .subscribe(statistic => {
        this.newConnects = statistic.newConnects;
      });
  }

  getStats1() {
    this.reportService.getConnects(this.currentCompany.id).then((res:any)=>{
        //console.log("C====" + JSON.stringify(res));
        if (res.status == 'OK') {
            this.newConnects = res.data;

            console.log(this.newConnects);
        }
    })
}



}
